<div *ngIf="!this.mergeOutputAudioStreams" #audioHolder ></div>